export const CONTACT = {
  brand: "SC Security",
  parent: "SC Electrical & Building Services",
  email: "info@scsecurity.uk",
  phone: "+44 020 3355 8449",
  phoneHref: "tel:+442033558449",
  address: "3rd Floor, 86–90 Paul Street, London EC2A 4NE, United Kingdom",
  serviceArea: "London & Berkshire, United Kingdom",
  hours: "Mon–Sat · 08:00–18:00",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Ajax", href: "#ajax-range" },
  { label: "Why Us", href: "#manifesto" },
  { label: "Contact", href: "#quote" },
];

export const SERVICES = [
  {
    id: "cctv",
    index: "01",
    title: "CCTV Installation",
    tag: "Surveillance",
    desc: "4K IP camera systems with remote monitoring, night vision and cloud recording for total visibility, day and night.",
    image: "https://images.pexels.com/photos/13156207/pexels-photo-13156207.jpeg",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    id: "lr",
    index: "02",
    title: "LR Systems",
    tag: "Long Range",
    desc: "Long-range wireless detection and perimeter security for large estates and commercial sites.",
    span: "md:col-span-1",
  },
  {
    id: "access",
    index: "03",
    title: "Access Control",
    tag: "Entry",
    desc: "Keypads, fobs and biometric entry that lock down who goes where — and when.",
    image: "https://images.unsplash.com/photo-1599770643145-3d8045e732e7",
    span: "md:col-span-1",
  },
  {
    id: "intercoms",
    index: "04",
    title: "Intercoms",
    tag: "Audio / Video",
    desc: "Video door entry and multi-unit intercom systems — screen every visitor before you open up.",
    image: "https://images.unsplash.com/photo-1558002038-1055907df827",
    span: "md:col-span-1",
  },
  {
    id: "maintenance",
    index: "05",
    title: "Maintenance",
    tag: "Domestic & Commercial",
    desc: "Scheduled servicing, fault-finding and rapid call-outs keeping your systems live 24/7.",
    span: "md:col-span-1",
  },
];

export const SERVICE_OPTIONS = [
  "CCTV Installation",
  "LR Systems",
  "Access Control",
  "Intercoms",
  "Maintenance",
  "Full Security Survey",
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Certified installers, not resellers",
    body: "Every system is designed, wired and commissioned by our own electrical engineers — a natural extension of SC Electrical & Building Services.",
  },
  {
    no: "02",
    title: "Ajax-grade hardware",
    body: "As a partner of Ajax Security Systems we deploy award-winning, grade-2 verified equipment trusted across Europe.",
  },
  {
    no: "03",
    title: "Domestic & commercial",
    body: "From a single home camera to a multi-site commercial estate, the same obsessive standard applies to every job.",
  },
  {
    no: "04",
    title: "Monitored & maintained",
    body: "We don't disappear after install. Remote diagnostics, servicing and rapid call-outs keep you protected long term.",
  },
];
